"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPhone = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconPhone = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M10.618 13.382c1.781 1.781 3.844 3.484 4.66 2.669 1.167-1.168 1.887-2.184 4.46-.116 2.573 2.069.597 3.447-.534 4.579-1.305 1.305-6.17.068-10.978-4.74S2.18 6.102 3.486 4.797c1.132-1.131 2.51-3.107 4.579-.534 2.068 2.573 1.052 3.293-.116 4.46-.815.816.888 2.879 2.669 4.66z"
}));
exports.IconPhone = IconPhone;
//# sourceMappingURL=IconPhone.js.map